module.exports = __webpack_public_path__ + "media/06-wpa-serotonin.530586bc.mp4";